import axios from 'axios';

// Thin wrapper around /api/lessontopics (the new Lesson<->Topic many-to-many
// link) - same shape as every other simple join-entity endpoint in this app
// (see courses/api.js's getList/createOne/deleteOne), kept local to this
// feature since only LessonTopicFlyout.jsx/TopicLessonFlyout.jsx use it.

export function getLessonTopics(lessonId) {
   return axios.get('/api/lessontopics?lesson=' + lessonId, { withCredentials: true });
}

export function getTopicLessons(topicId) {
   return axios.get('/api/lessontopics?topic=' + topicId, { withCredentials: true });
}

// One request for a whole lesson-list view (Events.jsx/GroupLessonsList.jsx)
// instead of one per row.
export function getLessonTopicsBulk(lessonIds) {
   if (!lessonIds || lessonIds.length === 0) {
      return Promise.resolve({ data: [] });
   }
   return axios.get('/api/lessontopics?lessonIds=' + lessonIds.join(','), { withCredentials: true });
}

export function createLessonTopic(lessonId, topicId) {
   // Bare ids, NOT nested {id:...} objects - confirmed directly against the
   // live backend (LessonDeserializer/TopicDeserializer parse a raw
   // number/string token, not a JSON object - a nested shape 400s with
   // "JsonMappingException: For input string: '{'").
   return axios.post('/api/lessontopics', JSON.stringify({ lesson: lessonId, topic: topicId }), {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
   });
}

export function deleteLessonTopic(id) {
   return axios.delete('/api/lessontopics/' + id, { withCredentials: true });
}
